<template>
    <v-card class="px-3 py-2">
        <v-card-text>
            <v-form class="mb-5" height="200px">
                <v-container>
                    <v-row jusify="center">
                        <v-col cols="12">
                            <strong>Company Information</strong>
                        </v-col>
                        <v-col cols="6" md="3">          
                            <v-text-field label="Company" v-model="company" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field label="Location" v-model="location" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field label="Number of Renters" type="number" v-model="numberOfRenters" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">          
                            <v-select outlined :items="tiers" v-model="tierType" label="Tier type" @change="alterTierTypes">
                            </v-select>
                        </v-col>
                        <v-col cols="12"> 
                            <v-text-field outlined v-model="mostRecentNote">
                                <div slot="label">
                                    Notes about your interactions with this company, so far... Include as much as possible...
                                </div>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row jusify="center">
                        <v-col cols="12">
                            <strong>Contact Information</strong> <small> - Your main point of contact so far</small>
                        </v-col>
                        <v-col cols="6" md="3">          
                            <v-text-field class="" label="Contact Full Name" v-model="contactName" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field label="Contact Phone Number" type="number" v-model="contactNumber" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field label="Contact Email" type="email" v-model="contactEmail" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">          
                            <v-text-field class="" label="Contact Job Title" v-model="contactJobTitle" outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row jusify="center">
                        <v-col cols="12">
                            <strong>Contract Information</strong>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field outlined v-model="contractReceived" label="Contract Received..." prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="contractReceived" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="6" md="3">
                             <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field outlined v-model="firstPaymentReceived" label="Payment Received..." prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="firstPaymentReceived" @input="menu3 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row jusify="center">
                        <v-col cols="12">
                            <strong>Billing Information</strong> <small> - Make sure you include VAT</small>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field :disabled="!enterprise" label="Setup Fee" type="number" v-model="setupFee" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field :disabled="!branded" label="Monthly Fee" type="number" v-model="monthlyFee" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field :disabled="!enterprise" label="Annual Fee" type="number" v-model="annualFee" outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field :disabled="essential" label="Billing Date" hint="Day of the month to charge 1 - 28" type="number" v-model="billingDate" outlined></v-text-field>
                        </v-col>
                        <v-col xs6 sm4>
                            <v-text-field label="Gifted Premium Access Fee" type="number" v-model="giftedFee" outlined></v-text-field>
                        </v-col>
                        <v-col xs6 sm4>
                            <v-text-field :disabled="enterprise" label="Acquired Premium Fee" type="number" v-model="acquiredFee" outlined></v-text-field>
                        </v-col>
                        <v-col xs6 sm4>
                            <v-text-field :disabled="enterprise" label="We take from Premium" type="number" v-model="weTakeFromPremium" outlined></v-text-field>
                        </v-col>
                    </v-row>
                   <v-card-actions>
                       <v-spacer></v-spacer>
                        <v-btn @click="createClient()" color="green" class="button-style" dark> 
                            Add Client
                        </v-btn>
                        <v-btn @click="$emit('clicked', true)" color="red" class="button-style" dark> 
                            Cancel
                        </v-btn>
                   </v-card-actions>
                </v-container>
            </v-form>
        </v-card-text>
    </v-card>

</template>
<script>
import moment from 'moment'
import uuidv4 from 'uuid/v4'
export default {
    name: 'AddClient',
    data(){
        return {
        // top level data
            tiers: ['Essential', 'Branded', 'Enterprise'],
            currentAdminUser: {},

        // client data
            companyID: '',
            company: '',
            location: '',
            numberOfRenters: null,
            tierType: '',
            contactName: '',
            contactNumber: '',
            contactEmail: '',
            contactJobTitle: '',

        // billing data
            monthlyFee: null,
            setupFee: null,
            annualFee: null,
            giftedFee: null,
            acquiredFee: null,
            weTakeFromPremium: null,
            billingDate: null,

        // task data
            contractReceived: null,
            firstPaymentReceived: null,
        
        // note data
            mostRecentNote: null,

        // stepper toggle
            step: 1,

        // datepicker data
            menu: false,
            modal: false,
            menu2: false,
            menu3: false,

        // tier selector data
            enterprise: true,
            branded: true,
            essential: true
        }
    },
    methods: {
        getUser(){
            this.currentAdminUser = this.$store.getters.currentAdminUser
        },
        alterTierTypes(){
           if(this.tierType == 'Essential'){
               this.essential = true
               this.branded = false
               this.enterprise = false
           }else if(this.tierType == 'Branded'){
               this.essential = false
               this.branded = true
               this.enterprise = false
           }else{
               this.essential = false
               this.branded = false
               this.enterprise = true
           }
        },
        cancelAddClient(){
            this.$emit('clicked', 'true')
        },
        createClient(){
            this.currentAdminUser = this.$store.getters.currentAdminUser
        // global time for all elements
            var time = Number(new Date())
            this.companyID = uuidv4()
        // initiate fixed elements
            var newClient = {} 
            var noteObject = null //done
            var billing = {}
            var taskTitles = null
            var contactInfo = {}
        // create task text array for different tiers
            var tasksTitlesEssential = [
                { text: 'Contract Signed' },
                { text: 'Platform Created' },
                { text: 'Platform explained' },
                { text: 'Users Received' },
                { text: 'Password Changed' },
                { text: 'GDPR Addressed' },
                { text: 'Announcement Email' },
                { text: 'Users Cleaned' },
                { text: 'Users Uploaded' }
            ]
            var tasksTitlesBranded = [
                { text: 'Contract Signed' },
                { text: 'First Payment' },
                { text: 'Platform Created' },
                { text: 'Platform Confirmed' },
                { text: 'Platform explained' },
                { text: 'Payment Card Connected' },
                { text: 'Password Changed' },
                { text: 'Primary user defined' },
                { text: 'Users Received' },
                { text: 'GDPR Addressed' },
                { text: 'Announcement Email' },
                { text: 'Users Cleaned' },
                { text: 'Users Uploaded' }
            ]
            var tasksTitlesEnterprise = [
                { text: 'Contract Signed' },
                { text: 'First Payment' },
                { text: 'Platform Created' },
                { text: 'Platform Confirmed' },
                { text: 'Platform explained' },
                { text: 'Payment Card Connected' },
                { text: 'Password Changed' },
                { text: 'Primary user defined' },
                { text: 'Users Received' },
                { text: 'GDPR Addressed' },
                { text: 'Announcement Email' },
                { text: 'Users Cleaned' },
                { text: 'Users Uploaded' }
            ]
        // create billing objects for different tiers
            var billingEssential = {
                monthlyFee: 0,
                annualFee: 0,
                giftedFee: this.giftedFee,
                acquiredFee: this.acquiredFee,
                weTakeFromPremium: this.weTakeFromPremium,
                billingDate: this.billingDate
            }
            var billingBranded = {
                monthlyFee: this.monthlyFee,
                annualFee: 0,
                giftedFee: this.giftedFee,
                acquiredFee: this.acquiredFee,
                weTakeFromPremium: this.weTakeFromPremium,
                billingDate: this.billingDate
            }
            var billingEnterprise = {
                monthlyFee: this.monthlyFee,
                annualFee: this.annualFee,
                giftedFee: this.giftedFee,
                acquiredFee: this.acquiredFee,
                weTakeFromPremium: this.weTakeFromPremium,
                billingDate: this.billingDate
            }
        // calculate tier
            newClient.tierType = this.tierType
            if(this.tierType == 'Essential'){
                taskTitles = tasksTitlesEssential
                billing = billingEssential
            }else if(this.tierType == 'Branded'){
                taskTitles = tasksTitlesBranded
                billing = billingBranded
            }else{
                taskTitles = tasksTitlesEnterprise
                billing = billingEnterprise
            }
        // create note object and update main details 
            if(this.mostRecentNote !== null){
                newClient.mostRecentNote = this.mostRecentNote
                newClient.mostRecentNoteTime = (time + 1000).toString()
                newClient.mostRecentNoteAuthor = this.currentAdminUser.email
                noteObject = {
                    company: this.company,
                    text: this.mostRecentNote,
                    star: false,
                    time: time.toString(),
                    authorEmail: this.currentAdminUser.email,
                    authorFirstName: this.currentAdminUser.firstName,
                    authorLastName: this.currentAdminUser.lastName,
                    authorShort: this.currentAdminUser.short,
                    type: 'Onboarding Comment',
                    companyID: this.companyID,
                    stage: 'Onboarding'
                }
            } else {
                newClient.mostRecentNoteAuthor = null
                newClient.mostRecentNoteTime = null
                newClient.mostRecentNote = null
            }
        // calculate task numbers
            if(this.contractReceived !== null){
                var totalTasks = Number(taskTitles.length)
                var completedTasks = 0            
                if(this.contractReceived !== null){
                    completedTasks ++
                }else{
                    completedTasks = completedTasks
                }
                if(this.firstPaymentReceived !== null){
                    completedTasks ++
                }else{
                    completedTasks = completedTasks
                }
// create client object and add to database
                newClient.id = this.companyID
                newClient.addedBy = this.currentAdminUser.firstName + ' ' + this.currentAdminUser.lastName
                newClient.company = this.company
                newClient.contactEmail = this.contactEmail
                newClient.contactJobTitle = this.contactJobTitle
                newClient.contactName = this.contactName
                newClient.contactNumber = Number(this.contactNumber)
                newClient.createdBy = this.currentAdminUser.firstName + ' ' + this.currentAdminUser.lastName
                newClient.location = this.location
                newClient.numberOfRenters = Number(this.numberOfRenters)
                newClient.stage = 'Onboarding'
                newClient.contractReceived = moment(this.contractReceived).format('x').toString()
                newClient.completedManagementTasks = 0
                newClient.totalManagementTasks = 0
                newClient.needsAttention = false
                newClient.happinessRating = 0
                newClient.createdDate = time.toString()
                newClient.updatedDate = null
                newClient.updatedBy = null
                newClient.totalOnboardingTasks = totalTasks
                newClient.completedOnboardingTasks = completedTasks
                newClient.primaryContact = this.contactEmail
        // Extra Stuff
                newClient.primaryGoal = '',
                newClient.secondaryGoal = '',
                newClient.type = '',
                newClient.branchCount = 0,
                newClient.propertyCount = 0,
                newClient.landlordCount = 0,
                newClient.averageRent = 0,
                newClient.propertyManagementCharge = 0,
                newClient.addUserProcess = '',
                newClient.removeUserProcess = '',
                newClient.propertyMaintenanceTool = '',
                newClient.userTypes = '',
                newClient.aob = '',
                newClient.contractLength = 0
                firebase.firestore().collection('clients').doc(newClient.id).set(newClient)
// add tasks
            // loop and enrich the array of tasks and add to tasks collection as individual documents in database
                for (var i = 0, len = taskTitles.length; i < len; i++) {
                    var taskName = moment(time + i).format('x').toString()
                    var task = {}
                    task.authorEmail = this.currentAdminUser.email,
                    task.authorFirstName = this.currentAdminUser.firstName,
                    task.authorLastName = this.currentAdminUser.lastName,
                    task.authorShort = this.currentAdminUser.short,
                    task.company = this.company,
                    task.companyID = this.companyID,
                    task.createdDate = taskName,
                    task.star = false,
                    task.stage = 'Onboarding',
                    task.text = taskTitles[i].text
                    task.time = taskName
                    task.type = 'Onboarding Task Created'
                    if(taskTitles[i].text == 'Contract Signed' && this.contractReceived !== null){
                        task.completed = true
                        task.completedBy = this.currentAdminUser.short
                        task.completedDate = taskName
                    }else if (taskTitles[i].text == 'First Payment' && this.firstPaymentReceived !== null){
                        task.completed = true
                        task.completedBy = this.currentAdminUser.short
                        task.completedDate = taskName
                    }else{
                        task.completed = false
                        task.completedBy = null
                        task.completedDate = null
                    }
                    firebase.firestore().collection('clients').doc(newClient.id).collection('tasks').doc(taskName).set(task)
                }
// add contact info
                contactInfo = {
                    contactEmail: this.contactEmail,
                    contactJobTitle: this.contactJobTitle,
                    contactName: this.contactName,
                    contactNumber: this.contactNumber,
                    contactType: 'Primary'
                }
                firebase.firestore().collection('clients').doc(newClient.id).collection('contact-information').doc(this.contactEmail).set(contactInfo)
// add billing
                firebase.firestore().collection('clients').doc(newClient.id).collection('billing').doc('payment-settings').set(billing)
// add note
                if(noteObject !== null){
                    firebase.firestore().collection('clients').doc(newClient.id).collection('onboarding-notes').doc(time.toString()).set(noteObject)
                }else{
                    noteObject = null
                }
// add activity to activity history
                let activity = {
                    company: newClient.company,
                    text: 'A new "' + this.tierType + '" client has been added!',
                    star: false,
                    time: time.toString(),
                    authorEmail: this.currentAdminUser.email,
                    authorFirstName: this.currentAdminUser.firstName,
                    authorLastName: this.currentAdminUser.lastName,
                    authorShort: this.currentAdminUser.short,
                    type: 'New Client',
                    companyID: newClient.id,
                    stage: 'Sales'
                }
                firebase.firestore().collection('activity').doc(time.toString()).set(activity)
// router push and store updates
                let currentClient = { id: newClient.id, name: newClient.company, stage: 'Onboarding'}
                this.$store.dispatch('setCurrentClient', currentClient)
                this.$router.push('/account-view/' + this.companyID)
                this.$emit('clicked', true)
            } else {
                alert('Make sure you have a contract received date before adding to this system')
            }
        }
    },
    mounted(){
        this.getUser()
    }
}
</script>

<style>

</style>